function zoneFilters() {
  $('.ipWidget-SiteMaps .map-filter input').change(function() {
    if ($(this).is(':checked')) {
      $(this)
        .parent()
        .find('.map-filter__check')
        .css('display', 'block')
      for (var i = 0, len = window[$(this).attr('id')].length; i < len; i++) {
        window[$(this).attr('id')][i].setOpacity(overlayOpts.opacity)
      }
    } else {
      $(this)
        .parent()
        .find('.map-filter__check')
        .hide()
      for (var i = 0, len = window[$(this).attr('id')].length; i < len; i++) {
        window[$(this).attr('id')][i].setOpacity(0)
      }
    }
  })
}

export { zoneFilters }
